import { Pipe, PipeTransform, inject } from '@angular/core';
import { BdGraphApiUser } from './user.model';
import { BdPermissionsUsersAdminService } from './users-admin.service';
import { firstValueFrom } from 'rxjs';

@Pipe({
  name: 'userAdmin',
  standalone: true,
})
export class BdPermissionUserAdminPipe implements PipeTransform {
  private _usersService = inject(BdPermissionsUsersAdminService);


  transform(value: string): Promise<BdGraphApiUser | undefined> {
    return firstValueFrom(this._usersService.getById(value));
  }
}
